import { customStepValidation } from "./custom-step-validation";

export class Stepper {
    constructor(stepperElement) {
        console.log('init stepper', stepperElement);
        if (!stepperElement) return
        this.stepperElement = stepperElement;
        this.events = {
            stepChanged: [],
            completed: [],
            uncompleted: []
        };
        this.stepsContainer = stepperElement.querySelector(".steps");
        this.steperContent = stepperElement.querySelector(".stepper-content");
        this.steps = [...this.stepsContainer.querySelectorAll(".step")].map((step, index) => {
            return new Step(step, index, this);
        });
        this.buttons = stepperElement.querySelector(".buttons");
        this.next = new NextButton(this.buttons.querySelector(".step-next"), this);
        this.back = new BackButton(this.buttons.querySelector(".step-back"), this);
        // this.complete = new CompleteButton(this.buttons.querySelector(".step-complete"), this);
        this.finish = new FinishButton(this.buttons.querySelector(".step-finish"), this);
        this.setActiveStep(0);
        // this.buttons.querySelector(".step-complete").focus();
    }

    nextStep() {
        this.setActiveStep(this.activeIndex + 1);
    }

    previousStep() {
        this.setActiveStep(this.activeIndex - 1);
    }

    // Add event listners to event object.
    listenForEvent(eventName, callback) {
        this.events[eventName].push(callback);
    }

    // @returns {boolean} True if all steps are complete.
    get isComplete() {
        return this.steps.filter(step => step.isComplete).length === this.steps.length;
    }

    // Runs all callbacks under the specified event key.
    emmitEvent(eventName) {
        this.events[eventName].forEach(callback => {
            callback(this);
        });
    }

    /**
     * This is the main function for setting the active step. This also emmits all
     * Event listners for children classes.
     */
    setActiveStep = index => {
        // Only run if actually changing the current step.
        if (this.activeIndex !== index) {
            // Change to specific index only if within steps range.
            if (index > -1 && index < this.steps.length) {
                this.activeIndex = index;
                // If not in range then default to first step.
            } else {
                this.activeIndex = 0;
            }
            this.emmitEvent("stepChanged");
            if (this.isComplete) {
                this.emmitEvent("completed")
            } else {
                this.emmitEvent("uncompleted")
            }
            this.toggleStepperContent()
        }
    };

    toggleStepperContent = () => {
        this.steperContent.classList.toggle("show");
        Array.from(this.steperContent.querySelectorAll('.step-content')).forEach(contentEl => {
            if (contentEl.dataset.step === this.activeIndex.toString()) {
                contentEl.style.display = 'block';
            } else {
                contentEl.style.display = 'none';
            }
        })
    }
}

/**
 * Each step get's it's own logic and functionality. This will listen for
 * changes made to the current active step.
 *
 * It will update it's UI when it is: focused, blured, or completed.
 *
 * On init and reset() it set's its icon element to it's proper index.
 *
 * @author Robert Todar <robert@roberttodar.com>
 */
class Step {
    constructor(step, index, stepper) {
        this.step = step;
        this.index = index;
        this.stepper = stepper;
        this.icon = step.querySelector(".icon");
        this.isComplete = false;
        this.isActive = false;
        stepper.listenForEvent("stepChanged", this.stepChanged);
        this.mouseEvent = this.step.addEventListener("mouseup", () => {
            if (customStepValidation(stepper.activeIndex)) {
                if (stepper.activeIndex === stepper.steps.length - 1) {
                    // console.log('reset last step');
                    stepper.steps[stepper.activeIndex].reset();
                }

                this.stepper.setActiveStep(this.index);
            }
        });
        this.reset();
    }

    // Event - sees if UI should be updated from getting or loosing focus.
    stepChanged = ({ activeIndex }) => {
        if (activeIndex === this.index) {
            this.setFocus();
        } else {
            this.looseFocus();
        }
    };

    setFocus() {
        if (!this.isActive) {
            this.step.classList.add("active");
            this.isActive = true;
        }
    }

    looseFocus() {
        if (this.isActive) {
            this.step.classList.remove("active");
            this.isActive = false;
        }
    }

    complete() {
        this.isComplete = true;
        this.step.classList.add("complete");
        // this.icon.innerHTML = '<i class="material-icons">ok</i>';
    }


    reset() {
        this.isComplete = false;
        this.icon.innerHTML = this.index + 1;
    }
}

/**
 * This is a generic Button class meant to be extended to all the other
 * buttons.
 *
 * It really just updates the UI from being disabled|enabled and displayed.
 *
 * @note I can't figure out how to have this.stepper.listenForEvent("stepChanged", this.stepChanged);
 *  within this class??
 */
class Button {
    constructor(el, stepper) {
        this.stepper = stepper;
        this.el = el;
        this.el.addEventListener("click", this.mouseup.bind(this));
    }

    disable() {
        this.el.disabled = true;
    }

    enable() {
        this.el.disabled = false;
    }

    hide() {
        this.el.style.display = "none";
    }

    show() {
        this.el.style.display = "inline-block";
    }
}

/**
 * Next button moves the active step forward.
 * It is disabled if at the end of the steps.
 */
class NextButton extends Button {
    constructor(el, stepper) {
        super(el, stepper);
        this.stepper.listenForEvent("stepChanged", this.stepChanged);
    }

    mouseup() {
        const { setActiveStep, activeIndex, steps } = this.stepper;
        if (customStepValidation(activeIndex)) {
            steps[activeIndex].complete();
            setActiveStep(activeIndex + 1);
        }
    }

    stepChanged = ({ activeIndex, steps }) => {
        if (activeIndex === steps.length - 1) { // last step
            // console.log('last step');
            this.disable();
            steps[activeIndex].complete();
            // this.emmitEvent("completed");
        }
        if (activeIndex < steps.length - 1) {
            // steps[activeIndex].reset();
            this.enable();
        }
    };
}

/**
 * Back button moves the active step backward.
 * It is disabled if at the start of the steps.
 */
class BackButton extends Button {
    constructor(el, stepper) {
        super(el, stepper);
        this.stepper.listenForEvent("stepChanged", this.stepChanged);
    }

    mouseup() {
        const { setActiveStep, activeIndex, steps } = this.stepper;

        if (activeIndex === steps.length - 1) {
            // console.log('reset last step');
            steps[activeIndex].reset();
        }

        setActiveStep(activeIndex - 1);
    }

    stepChanged = ({ activeIndex }) => {
        if (activeIndex === 0) this.disable();
        if (activeIndex > 0) this.enable();
    };
}

/**
 * Complete button calls to replace the active step index with a checkmark icon.
 * It is disabled if current step is complete already.
 * Is also hidden once all steps are complete.
 */
class CompleteButton extends Button {
    constructor(el, stepper) {
        super(el, stepper);
        this.stepper.listenForEvent("stepChanged", this.stepChanged);
        this.stepper.listenForEvent("completed", this.completed);
    }

    mouseup() {
        const { setActiveStep, activeIndex, steps } = this.stepper;
        steps[activeIndex].complete();
        setActiveStep(activeIndex + 1);
    }

    stepChanged = ({ steps, activeIndex }) => {
        if (steps[activeIndex].isComplete) {
            this.disable();
        } else {
            this.enable();
        }
    };

    completed = () => {
        this.hide();
    };
}

/**
 * Finish button currently just resets everything back to normal.
 * It is hidden by default and shown once all steps are complete.
 */
class FinishButton extends Button {
    constructor(el, stepper) {
        super(el, stepper);
        this.stepper.listenForEvent("completed", this.completed);
        this.stepper.listenForEvent("uncompleted", this.uncompleted);

    }

    mouseup() {
        const { setActiveStep, steps, complete, finish } = this.stepper;
        steps.forEach(step => {
            step.reset();
        });
        finish.hide();
        complete.show();
        complete.enable();
        setActiveStep(0);
    }

    completed = () => {
        this.show();
        this.el.focus();

        try {
            document.sta_custom_checkout.renderOverview()
        } catch (error) {
            console.log(error);
        }

    };

    uncompleted = () => {
        this.hide();
    };
}